var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ isIE: _vm.isIE },attrs:{"id":"app"}},[(!_vm.isIE)?[_c('router-view')]:_vm._e(),_c('module-browser-hint')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }